export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-5-480-6e80620c79abd38cba573ec5edf60395.png";